export const apartmentsGlobalSettings = {
  header: {
    title: "Configurações globais",
    sub: "Aplica-se a <strong>{count} apartamento</strong> da sua conta. | Aplica-se a <strong>{count} apartamentos</strong> da sua conta.",
    globalChip: "GLOBAL",
  },
  sections: {
    activate: "Ativar o motor de reservas",
    payment: "Quando o hóspede paga?",
    hold: "Tempo de retenção",
    request: "Modo de solicitação",
    link: "Link para compartilhar",
  },
  motor: {
    activeTitle: "Motor ativo",
    inactiveTitle: "Motor inativo",
    activeDesc: "Os hóspedes podem reservar diretamente pelo seu link.",
    inactiveDesc: "As reservas diretas estão desativadas para todos os seus apartamentos.",
    statusOn: "Ativo",
    statusOff: "Inativo",
  },
  payment: {
    onArrival: {
      name: "Pagar na chegada",
      hint: "Reserve sem custo, pague quando chegar.",
    },
    online: {
      name: "Pagar online",
      hint: "Pague quando a reserva for confirmada.",
    },
  },
  common: {
    saving: "Salvando…",
    onlyOnlineBadge: "Somente pagamento online",
  },
  hold: {
    desc: "O calendário fica bloqueado enquanto o hóspede conclui o pagamento.<br>Se não pagar dentro do tempo definido, <strong>a disponibilidade é liberada automaticamente</strong>.",
  },
  units: {
    min: "min",
    hour: "hora",
    hours: "horas",
  },
  request: {
    enabledTitle: "Solicitações ativadas",
    autoTitle: "Confirmação automática",
    enabledDesc: "O hóspede envia uma solicitação. Você aprova ou recusa pelo WhatsApp.",
    autoDesc: "A reserva é confirmada automaticamente assim que o pagamento é concluído.",
    tagControl: "Você controla quem reserva",
    tagWhatsapp: "WhatsApp quando chega uma solicitação",
  },
  link: {
    desc: "O mesmo link para todos os seus apartamentos. Compartilhe na sua bio, em campanhas ou em mensagens automáticas.",
    copyTitle: "Copiar",
    viewVisitor: "Ver como visitante",
    shareWhatsapp: "Compartilhar pelo WhatsApp",
  },
  callout: "Selecione um apartamento na barra lateral para definir <strong>Tarifas</strong>, <strong>Promoções</strong> e <strong>Cobranças</strong> individualmente.",
  savebar: {
    unsaved: "Alterações de retenção e modo de solicitação não salvas",
    save: "Salvar configurações",
  },
  toasts: {
    paymentUpdated: "Forma de pagamento atualizada.",
    paymentError: "Não foi possível salvar a forma de pagamento.",
    saved: "Configurações salvas.",
    saveError: "Não foi possível salvar.",
    linkCopied: "Link copiado.",
    copyError: "Não foi possível copiar.",
  },
  share: {
    whatsappText: "Olá 👋 Aqui está o link para reservar: {link}",
  },
};